import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';

import { LocalizationModule } from '@Core/Localization/localization.module';
import { CommonFormsModule } from '@Common/Forms/forms.module';
import { ChartsModule } from '@Common/Charts/charts.module';
import { MiscModule } from '@Common/Misc/misc.module';
import { CommonBasicModule } from '@Common/Basic/basic.module';
import { MentionsModule } from '@Common/Mentions/mentions.module';
import {TakeOverModule } from '@Common/TakeOver/take-over.module';
import { NetworkRadioComponent } from './components/NetworkRadio/network-radio.component';
import { SocialChartTooltipService } from './services/social-chart-tooltip.service';
import { TopTermsComponent } from './components/TopTerms/top-terms.component';
import { TopTermsListChartBlockComponent } from './components/TopTerms/TopTermsListChartBlock/top-terms-list-chart-block.component';
import { TopPostsComponent } from './components/TopPosts/top-posts.component';
import { SocialPostFeedCardComponent } from './components/SocialPostFeedCard/social-post-feed-card.component';
import { QuotaUsageDashboardComponent } from './components/QuotaUsageDashboard/quota-usage-dashboard.component'
import { QuotaUsageWidgetComponent } from './components/QuotaUsageWidget/quota-usage-widget.component';
import { MediaSubscriptionQuotaUsageWidgetComponent } from './components/QuotaUsageWidget/media-subscription-quota-usage-widget.component';
import { SocialListeningQuotaUsageWidgetComponent } from './components/QuotaUsageWidget/social-listening-quota-usage-widget.component';

const DECLARATIONS_EXPORTS = [
    NetworkRadioComponent,
    TopTermsComponent,
    TopTermsListChartBlockComponent,
    TopPostsComponent,
    SocialPostFeedCardComponent,
    QuotaUsageDashboardComponent,
    QuotaUsageWidgetComponent,
    MediaSubscriptionQuotaUsageWidgetComponent,
    SocialListeningQuotaUsageWidgetComponent
];

@NgModule({
    imports: [
        /* Angular */
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,

        /* Common/Core */
        LocalizationModule,
        CommonFormsModule,
        ChartsModule,
        MiscModule,
        CommonBasicModule,
        MentionsModule,
        TakeOverModule
    ],
    declarations: [
        ...DECLARATIONS_EXPORTS
    ],
    exports: [
        ...DECLARATIONS_EXPORTS
    ],
    providers: [
        SocialChartTooltipService
    ]
})
export class SocialSharedModule { }
